import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

function EditFormField({ label, children, className, horizontalAlign }) {
  const divClassNames = classnames(`EditFormField`, { 'EditFormField--horizontal': horizontalAlign }, className);
  return <div className={divClassNames}>
    <div className="EditFormField__label-container">
      <div className="EditFormField__label"> {label}
      </div>
    </div>
    {children}
  </div>;
}

EditFormField.displayName = 'EditFormField';

EditFormField.propTypes = {
  label: PropTypes.element.isRequired,
  children: PropTypes.element.isRequired,
  className: PropTypes.string.isRequired,
  horizontalAlign: PropTypes.bool,
};

export default EditFormField;
